// extracted by mini-css-extract-plugin
export default {"container_movies":"_movies_container_movies__H7LBE"};